<div class="input-group input-group-sm">
  <div class="position-relative flex-grow-1">
    <input #datepicker
           gtDatepickerInputMask
           class="form-control"
           [ngClass]="{'form-control-sm': inputSize == 'sm'}"
           [(ngModel)]="value"
           (ngModelChange)="valueChange($event)"
           (focus)="onFocus($event)"
           (blur)="onBlur($event)"
           [id]="id"
           [name]="name"
           [minDate]="minDate"
           [maxDate]="maxDate"
           placeholder="วว/ดด/ปปปป"
           ngbDatepicker
           container="body"
           autocomplete="off"
           #dateRef=ngbDatepicker
           [disabled]="disabled"/>
    @if (!disabled) {
      <span class="position-absolute top-50 end-0 translate-middle-y pointer me-3" (click)="dateRef.toggle();">
        <i class="bi bi-calendar-date"></i>
      </span>
    } @else {
      <span class="position-absolute top-50 end-0 translate-middle-y pointer me-3">
        <i class="bi bi-calendar-date"></i>
      </span>
    }
  </div>
</div>
